export const BUILD_SHA = __APP_SHA__;
export const BUILD_TIME = __APP_BUILD_TIME__;
